import React, { Fragment, PureComponent } from 'react';
import axios from 'axios';

import Header from './Header';
import StoreButtons from './StoreButtons';
import Section from './Section';
import SectionImages from './SectionImages';
import Image from './Image';
import Card from './Card';
import StoreAppsRibbon from './StoreAppsRibbon';

import headerPhone from '../assets/images/phone-dashboard.png';
import curveTwoWhite from '../assets/background-Images/curve-two-light-orange.png';
import curveOneWhite from '../assets/background-Images/curve-one-light-orange.png';
import products from '../assets/images/products.png';
import iphone6 from '../assets/images/phone-detail-view.png';
import iphonePay from '../assets/images/phone-checkout-view.png';
import trophyIcon from '../assets/images/icon-rewards.png';
import mindMapIcon from '../assets/images/icon-machine-learning.png';
import groupsIcon from '../assets/images/icon-social.png';

import { Element } from 'react-scroll';

const section1header = 'Products you want, at bottom prices';
const section1text =
	'Blidz is a new social shopping app with millions of quality products from Apple to Xiaomi offered below market prices. How can we offer quality brand products at the best prices anywhere? It\'s all because of you! Instead of spending money on marketing we invest in you by lowering our product costs. No middlemen + no extra mark-ups + no marketing expense = best prices.';

const section2header = 'Together, you save!';
const section2text =
	'DuoDeals allow you to get the most value-for-money. Simply ask a friend to buy together and both of you get the discount. Need a break from shopping? Use Blidz Points to join our games for a chance to win free items and Blidz Cash to reduce prices even more. Earn Points and Cash by sharing your referral link and get even bigger rewards.';

const section4header = 'Shop with a peace of mind';
const section4text =
	'At Blidz, the only thing you need to think about is hunting down that super bargain you always wanted. We have a 100% secure payment system, customer-friendly return policy and lightning-fast support to help you cash in on the best deals. Our delivery is fast often within 7-days. Simply select your favourite deals, and we take care of all the rest for you.';

class HomePage extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			articles: []
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		axios
			.get('https://api.rss2json.com/v1/api.json', {
				params: {
					rss_url: 'https://medium.com/feed/blidz'
				}
			})
			.then(({ data }) => {
				const articles = data.items.slice(0, 3);
				const sanitized = articles.map(article => {
					const description = article.description;
					const stripped = description.replace(
						/(?:<img[^>]*?>)|(?:<(figure)[^>]*?>.*<\/(\1)>)/gi,
						''
					);
					const longStringTrimmed = stripped.replace(
						/(<(\w+)\s[^>]*>)(.{15,})(<\/\2>)/gi,
						(match, p1, p2, p3, p4) => `${p1}${p3.substr(0, 10)}...${p4}`
					);

					return { ...article, description: longStringTrimmed };
				});

				this.setState({ articles: sanitized });
			});
	}

	render() {
		const cards = this.state.articles.map(({ title, thumbnail, description, link }, i) => {
			return <Card key={i} title={title} link={link} imgSrc={thumbnail} text={description} />;
		});

		return (
			<Fragment>
				<Header
					img={{ src: headerPhone, alt: 'mobile phone' }}
					heading={() => (
						<Fragment>
							<h2 style={{color: '#A2179C'}}>Together. </h2>
							<h2 style={{color: '#D2348C'}}>Great fun. </h2>
							<h2 style={{color: '#F8933B'}}>Big savings.</h2>
							<h1>
							Have fun saving money on great products with your friends.
							</h1>
							<StoreButtons />
						</Fragment>
					)}
				/>
				<Element name="features">
					<Section header={section1header} text={section1text} colReverse>
						<Image src={products} alt="collection of products" />
					</Section>
				</Element>
				<Section bgimg={curveOneWhite} text={section2text} header={section2header}>
					<Image src={iphone6} alt="mobile phone showing the app" />
				</Section>
				<SectionImages>
					<Card
						imgSrc={trophyIcon}
						title="Great rewards"
						text="We reward loyal Blidz users. Join hundreds of thousands of users to earn Cash, Points, Mystery Boxes, calendar rewards, and hunt Treasures to get free items ranging from smartphones to TVs and laptops!"
						wireframe
					/>
					<Card
						imgSrc={mindMapIcon}
						title="ML-boosted experience"
						text="Machine-learning tailors the best product recommendations and shopping experience for you anytime, anywhere. The more you shop with Blidz the better discounts and products we can offer you."
						wireframe
					/>
					<Card
						imgSrc={groupsIcon}
						title="Quality products"
						text="We are working with the biggest suppliers from all over the world and have carefully selected the best value-for-money products covering every category and price range. You want it? We have it!"
						wireframe
					/>
				</SectionImages>
				<Section
					bgimg={curveTwoWhite}
					header={section4header}
					text={section4text}
					colReverse
					rowReverse>
					<Image src={iphonePay} alt="mobile phone showing pay page" />
				</Section>
				{/* <SectionImages title="The Blidz Blog" link="https://medium.com/blidz">
					{cards}
				</SectionImages> */}
				<StoreAppsRibbon />
			</Fragment>
		);
	}
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js